import { useMutation } from '@tanstack/react-query'

import {
  ALLOWED_CONTENT_TYPES,
  dataOrThrow,
  type FileKey,
  MAX_FILE_SIZE_BYTES,
} from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export function useUploadFile() {
  const api = usePortalApi()
  return useMutation({
    mutationFn: async (file: File): Promise<FileKey> => {
      if (file.size > MAX_FILE_SIZE_BYTES) {
        throw new Error(`File exceeds the ${MAX_FILE_SIZE_BYTES / (1024 * 1024)} MB size limit`)
      }
      const contentType = ALLOWED_CONTENT_TYPES.find((type) => type === file.type)
      if (!contentType) {
        throw new Error(`"${file.name}" cannot be uploaded; this file type is not supported`)
      }
      const { uploadUrl, s3Key } = dataOrThrow(
        await api.post('/files/upload-url', {
          body: {
            fileName: file.name,
            contentType,
            sizeBytes: file.size,
          },
        })
      )
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file,
      })
      if (!response.ok) throw new Error('File upload failed. Please try again.')
      return { s3Key, fileName: file.name, contentType: file.type, sizeBytes: file.size }
    },
  })
}
